import styled from "styled-components";

export const ImageContainer = styled.figure`
  width: 40px;
  height: 40px;
  background-color: "GrayText";
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
